import { Injectable } from '@angular/core';
import { BreadcrumbSlotItem } from '@affinis/smartus-components/lib/breadcrumbs/breadcrumbs.types';
import { asyncScheduler, BehaviorSubject } from 'rxjs';
import { observeOn } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class BreadcrumbService {
  breadcrumbs: Array<BreadcrumbSlotItem> = [];

  private bc$ = new BehaviorSubject<Array<BreadcrumbSlotItem>>(
    this.breadcrumbs
  );
  bcChange$ = this.bc$.asObservable().pipe(observeOn(asyncScheduler));

  setBreadcrumbs(listSegments: Array<BreadcrumbSlotItem>) {
    this.breadcrumbs = listSegments;
    this.bc$.next(listSegments);
  }

  resetBreadcrumbs() {
    this.breadcrumbs = [];
    this.bc$.next([]);
  }
}
